import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ReportingSocialTemplatePublishId = Brand<number, 'ReportingSocialTemplatePublishId'>;
export const ReportingSocialTemplatePublishId = createBranded<ReportingSocialTemplatePublishId>();
